import React from "react";

const Products2 = () => {
  return <>Hello from New Products2</>;
};

export default Products2;
